/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { therapies } from './therapies'
import { ChapterNavigation } from 'components/ChapterNavigation'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { Scrollchor } from 'react-scrollchor'
import { Waypoint } from 'react-waypoint'

// TODO Set the correct article ID here
const ARTICLE_ID = '259694608534'

export function AppComponent() {
  const ChapterNavigationContent = [
    {
      name: <>Diagnosen</>,
      id: 'Diagnosen'
    },
    {
      name: <>Medikamente</>,
      id: 'Medikamente'
    },
    {
      name: <>Früherkennung</>,
      id: 'Früherkennung'
    },
    {
      name: <>Im Spital/Heim</>,
      id: 'Im Spital/Heim'
    }
  ]
  const [currentChapter, setCurrentChapter] = useState('Diagnosen')
  const [infoBoxOpen, setInfoBoxOpen] = useState(false)

  const toggleBox = () => {
    if (infoBoxOpen === false) {
      setInfoBoxOpen(true)
    } else {
      setInfoBoxOpen(false)
    }
  }

  //waypoint on enter
  const handleWaypointEnter = (e, which) => {
    let what = 'enter'
    if (e.currentPosition == 'inside' && e.previousPosition === 'below') {
      what = 'enter_from_bottom'
      if (which === 'top' && setCurrentChapter) {
        setCurrentChapter(currentChapter)
      }
    }
    if (e.currentPosition == 'inside' && e.previousPosition === 'above') {
      what = 'enter_from_top'
      if (which === 'bottom' && setCurrentChapter) {
        setCurrentChapter(currentChapter)
      }
    }
  }

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />
      <header>
        <div className='ui titleImage inverted'>
          {/* title desktop */}
          {browserCheck.isDesktop && (
            <div className='ui container headerContainer'>
              <div className='ui header headline'>
                <div className='headerWrapper'>
                  <h1>
                    {' '}
                    <div>
                      <span className='line1'>21</span>
                    </div>
                    Therapien, von denen Ärztinnen und Ärzte abraten
                  </h1>
                  <h2>
                    Medizinische Fachgesellschaften veröffentlichen seit ein
                    paar Jahren schwarze Listen mit Behandlungen und
                    Untersuchungen, die mehr schaden als nützen. Wir haben
                    einige der wichtigsten Empfehlungen zusammengestellt.
                  </h2>
                </div>
              </div>
            </div>
          )}
          <div className='Wrapper'>
            <div className='bloodTransfusion' />
          </div>
        </div>
        {/* title mobile & tablet */}
        {(browserCheck.isMobile || browserCheck.isTablet) && (
          <div className='ui container headerContainer'>
            <div className='ui header headline'>
              <div className='headerWrapper'>
                <h1>
                  {' '}
                  <div>
                    <span className='line1'>21</span>
                  </div>
                  Therapien, von denen Ärztinnen und Ärzte abraten
                </h1>
                <h2>
                  Medizinische Fachgesellschaften veröffentlichen seit ein paar
                  Jahren schwarze Listen mit Behandlungen und Untersuchungen,
                  die mehr schaden als nützen. Wir haben einige der wichtigsten
                  Empfehlungen zusammengestellt.
                </h2>
              </div>
            </div>
          </div>
        )}
      </header>

      <div className='ui vertical very fitted segment'>
        <ChapterNavigation
          content={ChapterNavigationContent}
          current={currentChapter}
        />
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>Felix Straumann</div>
              <div className='ta updated'>Aktualisiert am 21. Juni 2021</div>
            </div>
            <div className='ta text'>
              <p>
                Unnötige Behandlungen oder Abklärungen gehen nicht nur ins Geld,
                oft schaden sie auch Patientinnen und Patienten. Studien weisen
                solche Fehlversorgungen zunehmend nach, und auch in den Medien
                sind sie oft Thema, zuletzt die{' '}
                <Link href='995247632743' allowWordWrap>
                  massive Überverordnung von Säureblockern gegen Sodbrennen
                </Link>
                .
              </p>
              <p>
                Verschiedene medizinische Fachgesellschaften veröffentlichen
                inzwischen Listen mit Verfahren, von denen sie abraten. Das soll
                helfen, die Überversorgung in Spitälern und Arztpraxen
                einzudämmen. Angefangen hat im Jahr 2014 die Schweizerische
                Gesellschaft für Allgemeine Innere Medizin (SGAIM). Die
                Empfehlungen sind Teil der{' '}
                <Link href='https://www.smartermedicine.ch/de/home.html'>
                  Initiative «Smarter Medicine»
                </Link>
                . Vorbild ist «Choosing Wisely», eine ähnliche Initiative, die
                2011 in den USA lanciert wurde und seither weltweit Verbreitung
                findet.
              </p>
              <p>
                Die Negativlisten richten sich auch an medizinische Laien.
                Deshalb haben wir bereits 2017 zehn Empfehlungen aufbereitet,
                denen viele Patientinnen und Patienten im Alltag begegnen. Wir
                ergänzen diese nun hier mit einer Auswahl neuer Empfehlungen.
                Sie reichen von unnötigen{' '}
                <Scrollchor
                  to='#vitamin-d-tests'
                  animate={{ offset: -20, duration: 800 }}
                  className='scrollchor'
                >
                  Vitamin-D-Tests
                </Scrollchor>{' '}
                über falsch verschriebene{' '}
                <Scrollchor
                  to='#schlafmittel'
                  animate={{ offset: -20, duration: 800 }}
                  className='scrollchor'
                >
                  Schlafmittel
                </Scrollchor>{' '}
                und kontraproduktive{' '}
                <Scrollchor
                  to='#check-ups'
                  animate={{ offset: -20, duration: 800 }}
                  className='scrollchor'
                >
                  Check-ups
                </Scrollchor>{' '}
                bis hin zu vorschnell eingesetzten{' '}
                <Scrollchor
                  to='#blasenkathetern'
                  animate={{ offset: -20, duration: 800 }}
                  className='scrollchor'
                >
                  Blasenkathetern
                </Scrollchor>{' '}
                in Spitälern und Heimen. Fachlich unterstützt hat uns Prof. Dr.
                Stefan Neuner-Jehle vom Institut für Hausarztmedizin an der
                Universität Zürich.
              </p>
              <div
                className='info-box'
                onClick={toggleBox}
                style={{ marginTop: '2em' }}
              >
                <div className='titleContainer'>
                  <div className='left-side'>
                    <div className='title'>
                      Fünf Fragen, die Sie beim Arztbesuch stellen sollten
                    </div>
                  </div>
                  <div className='right-side'>
                    <i
                      className={
                        infoBoxOpen
                          ? 'angle up large icon'
                          : 'angle down large icon'
                      }
                    />
                  </div>
                </div>
                {infoBoxOpen && (
                  <div>
                    Um sich für oder gegen eine Behandlung entscheiden zu
                    können, empfiehlt «Smarter Medicine», dass Sie beim Arzt
                    oder der Ärztin folgende fünf Fragen stellen:
                    <ol>
                      <li>Gibt es mehrere Behandlungsmöglichkeiten?</li>
                      <li>
                        Was sind die Vor- und Nachteile der empfohlenen
                        Behandlung?
                      </li>
                      <li>Wie wahrscheinlich sind die Vor- und Nachteile?</li>
                      <li>Was passiert, wenn ich nichts unternehme?</li>
                      <li>Was kann ich selbst tun?</li>
                    </ol>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className='ui vertical very fitted segment'>
          <div className='ui text container'>
            <div className='ta text'></div>
          </div>
        </div>

        {/* kategorie Diagnosen */}
        <div className='ui vertical segment'>
          <Waypoint
            onEnter={event => {
              if (
                event.currentPosition === 'inside' &&
                event.previousPosition === 'below'
              ) {
                setCurrentChapter('Diagnosen')
              }
            }}
          />

          <div className='ui text container category'>
            <h3 id='Diagnosen'>Diagnosen</h3>
          </div>

          {therapies
            .filter(f => f.category === 'Diagnosen')
            .map((i, index) => (
              <>
                <div className='ui vertical segment'>
                  <div className='ui vertical very fitted segment content'>
                    <div className='ui text container'>
                      <h4 className='chapter'>
                        {i.graphic}
                        <span>
                          <b>{i.nr}</b>
                        </span>
                        <div className='titleWrapper'>
                          <div className='title'>{i.title}</div>
                          <div className='subtitle'>{i.subtitle}</div>
                        </div>
                      </h4>{' '}
                    </div>
                    <div>{i.text}</div>
                  </div>
                </div>
              </>
            ))}
          <Waypoint
            onEnter={event => {
              if (
                event.currentPosition == 'inside' &&
                event.previousPosition === 'above'
              ) {
                setCurrentChapter('Diagnosen')
              }
            }}
            topOffset={'300px'}
          />
        </div>

        {/* kategorie Medikamente */}
        <div className='ui vertical segment colorBackground'>
          <Waypoint
            onEnter={event => {
              if (
                event.currentPosition === 'inside' &&
                event.previousPosition === 'below'
              ) {
                setCurrentChapter('Medikamente')
              }
            }}
          />

          <div className='ui text container category'>
            <h3 id='Medikamente'>Medikamente</h3>
          </div>

          {therapies
            .filter(f => f.category === 'Medikamente')
            .map((i, index) => (
              <>
                <div className='ui vertical segment'>
                  <div className='ui vertical very fitted segment content'>
                    <div className='ui text container'>
                      <h4 className='chapter'>
                        {i.graphic}
                        <span>
                          <b>{i.nr}</b>
                        </span>
                        <div className='titleWrapper'>
                          <div className='title'>{i.title}</div>
                          <div className='subtitle'>{i.subtitle}</div>
                        </div>
                      </h4>{' '}
                    </div>
                    <div>{i.text}</div>
                  </div>
                </div>
              </>
            ))}

          <Waypoint
            onEnter={event => {
              if (
                event.currentPosition == 'inside' &&
                event.previousPosition === 'above'
              ) {
                setCurrentChapter('Medikamente')
              }
            }}
            topOffset={'300px'}
          />
        </div>

        {/* kategorie Früherkennung */}
        <div className='ui vertical segment'>
          <Waypoint
            onEnter={event => {
              if (
                event.currentPosition === 'inside' &&
                event.previousPosition === 'below'
              ) {
                setCurrentChapter('Früherkennung')
              }
            }}
          />

          <div className='ui text container category'>
            <h3 id='Früherkennung'>Früherkennung</h3>
          </div>

          {therapies
            .filter(f => f.category === 'Früherkennung')
            .map((i, index) => (
              <>
                <div className='ui vertical segment'>
                  <div className='ui vertical very fitted segment content'>
                    <div className='ui text container'>
                      <h4 className='chapter'>
                        {i.graphic}
                        <span>
                          <b>{i.nr}</b>
                        </span>
                        <div className='titleWrapper'>
                          <div className='title'>{i.title}</div>
                          <div className='subtitle'>{i.subtitle}</div>
                        </div>
                      </h4>{' '}
                    </div>
                    <div>{i.text}</div>
                  </div>
                </div>
              </>
            ))}

          <Waypoint
            onEnter={event => {
              if (
                event.currentPosition == 'inside' &&
                event.previousPosition === 'above'
              ) {
                setCurrentChapter('Früherkennung')
              }
            }}
            topOffset={'300px'}
          />
        </div>

        {/* kategorie Im Spital/Heim */}
        <div className='ui vertical segment colorBackground'>
          <Waypoint
            onEnter={event => {
              if (
                event.currentPosition === 'inside' &&
                event.previousPosition === 'below'
              ) {
                setCurrentChapter('Im Spital/Heim')
              }
            }}
          />

          <div className='ui text container category'>
            <h3 id='Im Spital/Heim'>Im Spital/Heim</h3>
          </div>

          {therapies
            .filter(f => f.category === 'Im Spital/Heim')
            .map((i, index) => (
              <>
                <div className='ui vertical segment'>
                  <div className='ui vertical very fitted segment content'>
                    <div className='ui text container'>
                      <h4 className='chapter'>
                        {i.graphic}
                        <span>
                          <b>{i.nr}</b>
                        </span>
                        <div className='titleWrapper'>
                          <div className='title'>{i.title}</div>
                          <div className='subtitle'>{i.subtitle}</div>
                        </div>
                      </h4>{' '}
                    </div>
                    <div>{i.text}</div>
                  </div>
                </div>
              </>
            ))}

          <Waypoint
            onEnter={event => {
              if (
                event.currentPosition == 'inside' &&
                event.previousPosition === 'above'
              ) {
                setCurrentChapter('Im Spital/Heim')
              }
            }}
            topOffset={'300px'}
          />
        </div>
      </div>
      <Footer
        articleId={ARTICLE_ID}
        starColor='red'
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Text', 'Felix Straumann'],
          ['Grafiken', 'Patrick Vögeli, Jürg Candrian'],
          ['Digitale Umsetzung', 'Patrick Vögeli']
        ]}
      />
    </div>
  )
}
